<style>

  .file-upload-segment {
    min-height: 250px !important;
  }

</style>

<template>
  
  <div class="ui grid animated fadeIn">
    <div class="ui sixteen wide column">
      <file-upload
        ref="fileUpload"
        :uploadPath="`/certs/${this.cert.id}/attachments`"
        :loader="loadFiles"        
        @onRemove="onRemoveFile"
      /> 
    </div>
    <div class="ui sixteen wide column">
      <div class="ui segment">
        <h4 class="ui dividing header">Observações</h4>
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <textarea ref="commentsInput" rows="8" @keyup="canSaveComments = true"></textarea>
            </div>
          </div>
        </div>
        <button class="ui button" :class="{ disabled: !canSaveComments, loading: savingComments }" @click="onSaveComments()">
          <i class="save icon"></i> Salvar
        </button>
      </div>
    </div>
  </div>    

</template>

<script>

  import CertService from "@/services/cert-service"
  import FileUpload from "@/components/file-upload"

  export default {
    
    name: "CertAttachmentsTab",

    data() {
      return {
        savingComments: false,
        canSaveComments: false,
        service: new CertService(),
      }
    },

    props: ["cert"],

    components: {
      FileUpload,
    },

    mounted() {
      
      this.$refs.fileUpload.loadFiles()      

      this.$refs.commentsInput.value = this.cert.attachmentComments || ""
    },

    methods: {

      async loadFiles() {
        return this.service.getAttachments(this.cert.id)        
      }, 

      async onRemoveFile(file) {

        try {

          await this.service.removeAttachment(this.cert.id, file) 
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      async onSaveComments() {

        if (this.savingComments)
          return

        this.savingComments = true  

        try {

          const comments = this.$refs.commentsInput.value

          await this.service.saveAttachmentComments(this.cert.id, comments) 

          this.$msg.success("Observações atualizadas")

          this.$emit("onSaveComments", comments)
          
        } catch (error) {
          
          this.$errorHandler(error)

        } finally {

          this.savingComments = false
          this.canSaveComments = false
        }
      },
    },
  }

</script>